import React from 'react';
import PropTypes from 'prop-types';
import Label from '../components/Label';
import FieldHelperText from '../components/FieldHelperText';

const withFormField = ({ messagePosition }) => (FieldComponent) => {
  const FormField = (props) => {
    const {
      id, label, helperText, error, success, required, containerClassName, ...otherProps
    } = props;
    const msgType = (error && 'error') || (success && 'success') || 'default';
    const message = error || success || helperText;
    const helper = !!message && (
      <FieldHelperText type={msgType}>{message}</FieldHelperText>
    );
    return (
      <div className={containerClassName}>
        {!!label && (
          <Label
            inputId={id}
            label={label}
            error={!!error}
            success={!!success}
            required={required}
          />
        )}
        {messagePosition === 'top' && helper}
        <FieldComponent
          id={id}
          error={!!error}
          success={!!success}
          {...otherProps}
        />
        {messagePosition === 'bottom' && helper}
      </div>
    );
  };
  FormField.propTypes = {
    id: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
    label: PropTypes.string,
    helperText: PropTypes.string,
    error: PropTypes.string,
    success: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    handleChange: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
  };
  FormField.defaultProps = {
    value: undefined,
    handleChange: undefined,
    containerClassName: undefined,
    label: undefined,
    helperText: undefined,
    error: undefined,
    success: undefined,
    required: undefined,
    disabled: undefined,
    defaultValue: undefined,
  };
  return FormField;
};

withFormField.propTypes = {
  messagePosition: PropTypes.string,
};

withFormField.defaultProps = {
  messagePosition: 'bottom',
};

export default withFormField;
